export default "__VITE_ASSET__BqLKjo7e__"